module.exports = __webpack_public_path__ + "img/question-background-blur.13a1a2b4.svg";